import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const BackgroundContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: ${(props) => (props.$fullWidth ? '100%' : '50%')};
  height: 100%;
  z-index: ${(props) => (props.$fullWidth ? 0 : -2)};
  overflow: hidden;
  opacity: ${(props) => (props.$fullWidth ? 0.35 : 0.4)};
  pointer-events: none;

  @media (max-width: 1023px) {
    width: 100%;
    opacity: ${(props) => (props.$fullWidth ? 0.3 : 0.28)};
  }
`;

const DnaStrand = styled(motion.div)`
  position: absolute;
  width: ${props => props.width || '300px'};
  height: ${props => props.height || '100%'};
  left: ${props => props.left || '20%'};
  top: ${props => props.top || '0'};
  opacity: ${props => props.opacity || 0.2};
  background: linear-gradient(
    ${props => props.angle || '90deg'},
    rgba(98, 0, 234, 0.1) 0%,
    rgba(3, 218, 198, 0.1) 100%
  );
  border-radius: 200px;
  transform-origin: center;
  filter: blur(${props => props.blur || '10px'});
`;

const DnaNode = styled(motion.div)`
  position: absolute;
  width: ${props => props.size || '20px'};
  height: ${props => props.size || '20px'};
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(187, 134, 252, 0.3) 0%,
    rgba(3, 218, 198, 0.1) 100%
  );
  left: ${props => props.left || '20%'};
  top: ${props => props.top || '20%'};
  filter: blur(2px);
`;

const DnaBackground = ({ fullWidth = false }) => {
  // Generate random DNA nodes
  const generateNodes = (count) => {
    const nodes = [];
    for (let i = 0; i < count; i++) {
      const size = Math.floor(Math.random() * 30) + 10 + 'px';
      nodes.push({
        id: i,
        size,
        left: Math.floor(Math.random() * 90) + 5 + '%',
        top: Math.floor(Math.random() * 90) + 5 + '%',
        duration: Math.random() * 10 + 10
      });
    }
    return nodes;
  };

  // Generate random DNA strands
  const generateStrands = (count) => {
    const strands = [];
    for (let i = 0; i < count; i++) {
      strands.push({
        id: i,
        width: Math.floor(Math.random() * 300) + 100 + 'px',
        height: Math.floor(Math.random() * 600) + 400 + 'px',
        left: Math.floor(Math.random() * 80) + 10 + '%',
        top: Math.floor(Math.random() * 50) - 20 + '%',
        opacity: (Math.random() * 0.2) + 0.05,
        angle: Math.floor(Math.random() * 360) + 'deg',
        duration: Math.random() * 20 + 40,
        blur: Math.floor(Math.random() * 10) + 5 + 'px'
      });
    }
    return strands;
  };

  const dnaNodes = generateNodes(20);
  const dnaStrands = generateStrands(5);

  return (
    <BackgroundContainer $fullWidth={fullWidth}>
      <div className="dna-background"></div>
      
      {dnaStrands.map(strand => (
        <DnaStrand
          key={`strand-${strand.id}`}
          width={strand.width}
          height={strand.height}
          left={strand.left}
          top={strand.top}
          opacity={strand.opacity}
          angle={strand.angle}
          blur={strand.blur}
          animate={{
            transform: [
              'scale(1) rotate(0deg)',
              'scale(1.05) rotate(2deg)',
              'scale(1) rotate(0deg)'
            ]
          }}
          transition={{
            duration: strand.duration,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
        />
      ))}
      
      {dnaNodes.map(node => (
        <DnaNode
          key={`node-${node.id}`}
          size={node.size}
          left={node.left}
          top={node.top}
          animate={{
            opacity: [0.2, 0.7, 0.2]
          }}
          transition={{
            duration: node.duration,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
        />
      ))}
    </BackgroundContainer>
  );
};

export default DnaBackground; 